import { Component, OnInit } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { encrypt_decript } from '../../../assets/js/Encription_Decription';
import { CommonDataService } from '../../providers/common-data.service';
import { Data, Route, Router } from '@angular/router';
import { Helper_Class } from '../../helper_class';
import { FilterpageComponent } from '../filterpage/filterpage.component';
import { pharmacy_helper } from '../Pharmcy_Helper';
import { PharmacyService } from '../pharmacy/pharmacy.service';
import { ipaddress } from '../../ipaddress';
import { AdminViewService } from '../../../app/Admin_module/admin-view/admin-view.service';
import { MenuViewService } from '../../../app/common-module/menu-view/menu-view.service';

@Component({
  selector: 'app-pharmacypastinformation',
  templateUrl: './pharmacypastinformation.component.html',
  styleUrls: ['./pharmacypastinformation.component.css']
})
export class PharmacypastinformationComponent implements OnInit {
  order_listarray = [];
  no_datacurrent: boolean = false;
  dtOptions: any = {};
  persons: any = [];
  masterSelected: boolean = false;
  checklist: any;
  checkedList: any;
  i = 0;
  public imei;
  public userinfo;
  public user_id;
  public hospitalid;
  public inpatientFlag;
  public App_type;
  public pharmacy_id: string;
  public ynopt1: boolean = true;
  public billEdit: boolean = false;
  public currentDate:any;
  public fromDate:any;
  public toDate:any;
  public filtertype;
  
  public nameList:any=[];
  public patName:string;
  public ordertype: string;
  public fname:string;
  public mr_no:string;
  public name_flag: boolean = false;
  public date_flag:boolean=true;
  public mrn_flag:boolean=false;

  constructor(public gservice: CommonDataService, public messageservice: PharmacyService, 
    public http: Http, public router: Router, public dialog: MatDialog, public adminService: MenuViewService) {

  }

  ngOnInit(): void {
    this.imei = Helper_Class.getIPAddress();
    this.userinfo = Helper_Class.getInfo();

    var getvalue2 = Helper_Class.getInfo().hospitals;
    for (var i = 0; i < getvalue2.length; i++) {
      this.hospitalid = getvalue2[0].hptl_clinic_id
    }

    this.filtertype = "date";
    this.ordertype="otc";
    this.getCurrentDate()
    this.dtOptions = {
      pagingType: 'simple_numbers_no_ellipses',
      pageLength: 10,
      "lengthMenu": [[5, 10, 25, 50, -1], [5, 10, 25, 50, "All"]],
      "columnDefs": [
      ],
      "language": {
        "search": "<img src='../../../assets/img/search.png' width='18px'/>",
        searchPlaceholder: "Search by bill no, name, delivery type, order type"
      },
      dom: '<"row"<"col-sm-6 col-xs-12"f><"col-sm-6 col-xs-12 d-flex justify-content-end"l>><"table-responsive"t><"row mt-1 d-flex"<"col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 pad_top_10"><"col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 text-center sm-order-last"i><"col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 text-center"p>>'
    };
   
    if(this.userinfo.user_type=="Admin") {
      this.billEdit = this.userinfo.bill_edit == "1" ? true : false;
    } else {
      this.billEdit = this.userinfo.hospitals[0].bill_edit == "1" ? true : false;
      if(this.billEdit == true) {
        Helper_Class.setBillEdit("1");
      }
    }
   
    var pharmacypastorder = "pastorder";
    pharmacy_helper.setpharmacyflow(pharmacypastorder);
    this.App_type = "out";
  }

  getCurrentDate() {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp.toString() + 'adm/curdate', { country: ipaddress.country_code },
      { headers: headers })
      .subscribe(
        response => {
          var obj = JSON.parse(response["_body"]);
          this.currentDate = obj.current_date;//display in html for maximum date
          this.fromDate = obj.current_date;
          this.toDate = obj.current_date;
          if (Helper_Class.getIsAdmin() != undefined) {
            this.pharmacy_id = this.userinfo.pharma_id;
            this.userTypeSelect("out");
          } else {
            this.PharmacyBranchList();
          }
        })
  }

  changeFilterType() {
    if (this.filtertype == "date") {
      this.date_flag = true;
      this.mrn_flag = false;
      this.name_flag = false;

    } else if (this.filtertype == "client") {
      this.date_flag = false;
      this.mrn_flag = false;
      this.name_flag = true;
      
    } else {
      this.date_flag = false;
      this.mrn_flag = true;
      this.name_flag = false;
    }
  }

  getPatientDetails() {
    if(this.patName.length >2){
      var send_data = JSON.stringify({
        pharma_id: this.pharmacy_id,
        name:this.patName.toUpperCase(),
        orderType:this.ordertype
      })
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      this.http.post(ipaddress.getIp + "pharmacontrol/gcbp/", send_data,
        { headers: headers }).subscribe(
          response => {
            var obj = response.json();
            if (obj.names != null) {
              this.nameList=[];
              for(var i=0;i<obj.names.length;i++){
                var lname=obj.names[i].last_name != undefined?encrypt_decript.Decript(obj.names[i].last_name):"";
                this.nameList.push({
                  name:encrypt_decript.Decript(obj.names[i].first_name)+" "+lname,
                  first_name: encrypt_decript.Decript(obj.names[i].first_name),
                  client_reg_id:obj.names[i].client_reg_id,
                });
              }
            }
          });
    }
  }

  selectPatient(name){
    this.fname=name.first_name;
    this.currentOrder(this.pharmacy_id, name.client_reg_id,name.first_name)
  }

  PharmacyBranchList() {
    this.user_id = this.userinfo.user_id
    var send_data = JSON.stringify({
      pharma_reg_id: this.user_id,
      imei: this.imei
    })
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp + "pharmacontrol/locbyregid/", send_data,
      { headers: headers }).subscribe(
        response => {
          //order_details
          var obj = response.json();
          if (obj.pharma != null) {
            this.pharmacy_id = obj.pharma[0].pharma_id;
            this.userTypeSelect("out");
            localStorage.setItem("pharma_id", obj.pharma[0].pharma_id);
          }
        });
  }

  currentOrder(pharma_id, clientid, fname) {//Current order
    var clnid;
    if(clientid != ''){
      clnid = clientid;
    }
    var send_data;
    var send_data;
    if(this.ordertype=="otc" && this.filtertype=="client"){
      send_data={
        pharma_id: pharma_id,
        flag: "delivered",
        inpatient_flag: this.inpatientFlag,
        fname:fname,
      }
    } else if(this.ordertype=="notc" && this.filtertype=="client"){
      send_data={
        pharma_id: pharma_id,
        flag: "delivered",
        inpatient_flag: this.inpatientFlag,
        client_reg_id:clnid,
      }

    } else if(this.ordertype=="otc" && this.filtertype=="mr_no"){
      send_data={
        pharma_id: pharma_id,
        flag: "delivered",
        inpatient_flag: this.inpatientFlag,
        mr_no:this.mr_no,
      }

    } else if(this.ordertype=="notc" && this.filtertype=="mr_no"){
      send_data={
        pharma_id: pharma_id,
        flag: "delivered",
        inpatient_flag: this.inpatientFlag,
        mr_no:this.mr_no,
      }

    } else {
      send_data={
        pharma_id: pharma_id,
        flag: "delivered",
        inpatient_flag: this.inpatientFlag,
        start_date: this.fromDate,
        end_date: this.toDate,
      }
    }
   
    this.order_listarray = [];
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp + "pharmacontrol/viewordersbyphar", JSON.stringify(send_data),
      { headers: headers }).subscribe(
        response => {
          //order_details
          var obj = response.json();
          if (obj.order_details != null) {
            this.no_datacurrent = false;
            for (var i = 0; i < obj.order_details.length; i++) {
              if (obj.order_details[i].first_name != null) {
                if (obj.order_details[i].description == "Door Delivery") {
                  var home_deltxt = "Home delivery";
                } else {
                  home_deltxt = obj.order_details[i].description;
                }

                if (obj.order_details[i].drug_details != null) {
                  var tabletarray = [];
                  for (var k = 0; k < obj.order_details[i].drug_details.length; k++) {
                    tabletarray.push({
                      tablet_name: obj.order_details[i].drug_details[k].type_name + " - " + obj.order_details[i].drug_details[k].drug_name + " " + obj.order_details[i].drug_details[k].quantity + " nos"
                    });
                  }
                }

                if (obj.order_details[i].middle_name != undefined && obj.order_details[i].middle_name != null) {
                  var m_name = encrypt_decript.Decript(obj.order_details[i].middle_name).toString();
                } else {
                  m_name = "";
                }

                if (obj.order_details[i].first_name != undefined && obj.order_details[i].first_name != null) {
                  var f_name = encrypt_decript.Decript(obj.order_details[i].first_name).toString();
                } else {
                  f_name = obj.order_details[i].del_name
                }

                if (obj.order_details[i].last_name != undefined && obj.order_details[i].last_name != null) {
                  var l_name = encrypt_decript.Decript(obj.order_details[i].last_name).toString();
                }

                this.order_listarray.push({
                  drug_purchase_id: obj.order_details[i].drug_purchase_id,
                  tot_name: f_name + " " + m_name + " " + l_name,
                  home_delivery: home_deltxt,
                  order_date: this.Date_Formate(obj.order_details[i].order_date),
                  tablet_data: tabletarray,
                  fin_year: obj.order_details[i].fin_year,
                });

                pharmacy_helper.setorderview(this.order_listarray);
              } else {
                if (obj.order_details[i].description == "Door Delivery") {
                  var home_deltxt = "Home delivery";
                } else {
                  home_deltxt = obj.order_details[i].description;
                }

                if (obj.order_details[i].drug_details != null) {
                  var tabletarray = [];
                  for (var k = 0; k < obj.order_details[i].drug_details.length; k++) {
                    tabletarray.push({
                      tablet_name: obj.order_details[i].drug_details[k].type_name + " - " + obj.order_details[i].drug_details[k].drug_name + " " + obj.order_details[i].drug_details[k].quantity + " nos"
                    });
                  }
                }

                if (obj.order_details[i].del_person != null) {
                  var del_name = obj.order_details[i].del_person;
                }

                this.order_listarray.push({
                  drug_purchase_id: obj.order_details[i].drug_purchase_id,
                  tot_name: del_name,
                  home_delivery: home_deltxt,
                  order_date: this.Date_Formate(obj.order_details[i].order_date),
                  tablet_data: tabletarray,
                  fin_year: obj.order_details[i].fin_year,
                });
              }
            }
          } else {
            this.no_datacurrent = true;
          }
        });
  }

  selectDate(data, value) {
    if (data != null) {
      if (value == "1") {
        this.fromDate = data;
      } else {
        this.toDate = data;
      }
    }
  }

  Date_Formate(data) {
    var Splitter = data.split("-");
    return Splitter[2] + "-" + Splitter[1] + "-" + Splitter[0];
  }

  order_View(Order_id, finyear) {
    var order_View = {
      AppFlow: "past_orders",
      "orderid": Order_id,
      value: "past",
      fin_year: finyear,
    }
    pharmacy_helper.setorderview(order_View);
    if (Helper_Class.getIsAdmin() != undefined) {
      this.adminService.sendMessage("pharmaBillingView");
    } else {
      Helper_Class.setBillPrint("1");
      this.messageservice.sendMessage('pharmacymoduleorderdetailview');
    }
  }

  editMedicine(Order_id, finyear) {
    var order_View = {
      AppFlow: "past_orders_edit",
      "orderid": Order_id,
      status: "2",
      value: "past_edit",
      fin_year: finyear
    }
    pharmacy_helper.setorderview(order_View);
    if (Helper_Class.getIsAdmin() != undefined) {
      this.adminService.sendMessage("pharmaBillingView");

    } else {
      this.messageservice.sendMessage('pharmacymoduleorderdetailview');
    }
  }

  optionsPopover() {
    const dialogRef = this.dialog.open(FilterpageComponent, {
      width: '25%',
      height: '180px',
    });
    dialogRef.afterClosed().subscribe(data => { });
  }

  userTypeSelect(page) {
    this.App_type = page;
    this.inpatientFlag = this.App_type == "in" ? true : false;
    this.currentOrder(this.pharmacy_id,'','');
  }

  change_type(id, value) {
    if (value == "yes") {
      this.ynopt1 = true;
      this.userTypeSelect('out');
    } else {
      this.ynopt1 = false;
      this.userTypeSelect('in');
    }
  }
}